import { renewMyPins } from '../api/relay/renewMyPins';
import { sessionDetailsQueryRequest } from '../api/relay/sessionDetails';
import {
  updateLivestreaming as updateLivestreamingApi,
  updateRoomLockPreference as updateRoomLockPreferenceApi,
  updateScreenshareFrameRate as updateScreenshareFrameRateApi,
  getRoomLockPreference, getScreenshareFrameRate
} from '../api/relay/updateProfile';
import { getLogger } from '../logger';
import { newEvent, ERROR, INFO } from '../notifications';

import {
  fetchSessionDetails, setRoomLockPreference,
  setScreenshareFrameRate, setUpdating
} from './session';


function maybeNotifyRegenPinsError() {
  newEvent(ERROR, 'regeneratePinsGenError', 'regeneratePinsGenError',
    "Error while updating pins.");
}


function notifyUpdateProfileError() {
  newEvent(ERROR, 'updateProfileError', 'updateProfileError',
    "Error while updating profile settings.");
}


function notifyUpdateProfileSuccess() {
  newEvent(INFO, 'updateProfileSuccess', 'updateProfileSuccess',
    "Profile saved successfully!");
}


export function regeneratePins(relay) {
  return (dispatch) => {
    renewMyPins(relay).then((_res) => {
      dispatch(fetchSessionDetails(relay, sessionDetailsQueryRequest));
    }).catch((_err) => {
      maybeNotifyRegenPinsError();
    });
  };
}


export function updateLivestreaming(relay, params) {
  const logger = getLogger('updateLivestreaming');

  return (_dispatch) => {
    updateLivestreamingApi(relay, params).then((_res) => {
      notifyUpdateProfileSuccess();
    }).catch((err) => {
      logger.error("GQL Api Error", err);

      notifyUpdateProfileError();
    });
  };
}

export function updateRoomLockPreference(relay, params) {
  const logger = getLogger('updateRoomLockPreference');

  return (dispatch) => {
    dispatch(setUpdating("roomLockPreference", true));
    updateRoomLockPreferenceApi(relay, params).then((res) => {
      dispatch(setRoomLockPreference(getRoomLockPreference(res)));
    }).catch((err) => {
      logger.error("GQL Api Error", err);
      dispatch(setUpdating("roomLockPreference", false));
      notifyUpdateProfileError();
    });
  };
}

export function updateScreenshareFrameRate(relay, params) {
  const logger = getLogger('screenshareFrameRate');

  return (dispatch) => {
    dispatch(setUpdating("screenshareFrameRate", true));
    updateScreenshareFrameRateApi(relay, params).then((res) => {
      dispatch(setScreenshareFrameRate(getScreenshareFrameRate(res)));
    }).catch((err) => {
      logger.error("GQL Api Error", err);
      dispatch(setUpdating("screenshareFrameRate", false));
      notifyUpdateProfileError();
    });
  };
}
